import { configureStore } from '@reduxjs/toolkit';
import reducer from './reducer';
import logger from 'redux-logger';
import { initialState } from './initial';
export { initStore };
export var store = initStore();
function initStore() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return configureStore({
    preloadedState: state,
    reducer: reducer,
    middleware: function middleware(getDefaultMiddleware) {
      return process.env.CHEGG_ENV !== 'prod' && process.env.NODE_ENV !== 'test' && process.env.NODE_ENV !== 'prod' && process.env.NODE_ENV !== 'production' && getDefaultMiddleware({
        serializableCheck: false
      }).concat(logger) || getDefaultMiddleware({
        serializableCheck: false
      });
    }
  });
}

// Infer the `RootState` and `AppDispatch` types from the store itself